import { Typography } from "antd";

import type { AvE2EProps } from "@av/components/types";

import type { ParagraphProps as AntdParagraphProps } from "antd/es/typography/Paragraph";

const { Paragraph: AntdParagraph } = Typography;

type ParagraphProps = AntdParagraphProps & AvE2EProps;

export function CustomParagraph(props: ParagraphProps) {
  const { testIdPrefix, ...rest } = props;

  return <AntdParagraph data-testid={`${testIdPrefix}-paragraph`} {...rest} />;
}
